import GoalError from './GoalError';
class InvalidGoalType extends GoalError {
    constructor(options) {
        super('The goal type is invalid', options);
    }
}
export default InvalidGoalType;
